import {radioAnatomy} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/unbound-method
const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(radioAnatomy.keys)

const baseStyle = definePartsStyle({
    control: {
        width: 'iconsSize.medium',
        height: 'iconsSize.medium',
        flexShrink: 0,
        borderColor: 'border.dark',
        _checked: {
            borderColor: 'border.dark',
            bg: 'background.default',
            color: 'text.primary',
        },
    },
})

export default defineMultiStyleConfig({baseStyle})
